export function getToken(nickName) {
  const AccessToken = require('twilio').jwt.AccessToken
  const ChatGrant = AccessToken.ChatGrant

  // Used when generating any kind of tokens
  const twilioAccountSid = 'ACef4b34b641dd19b7ad6d2a1c08aef295'
  const twilioApiKey = 'SKee3ab3b3bf5a277799117b1f4ff1fe0f'
  const twilioApiSecret = 'd4fi0PLiOYWimZsYf7R7wZxW1dcFrCkC'

  // Used specifically for creating Chat tokens
  const serviceSid = 'ISd0fa6ab091404aeebb2f233ba44f2ccc'
  const identity = nickName

  // Create a "grant" which enables a client to use Chat as a given user,
  // on a given device
  const chatGrant = new ChatGrant({
    serviceSid: serviceSid
  })

  // Create an access token which we will sign and return to the client,
  // containing the grant we just created
  const token = new AccessToken(
    twilioAccountSid,
    twilioApiKey,
    twilioApiSecret,
    { identity: identity }
  )

  token.addGrant(chatGrant)

  // Serialize the token to a JWT string
  //console.log(token.toJwt())
  return token.toJwt()
}
